import { Component, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { NGXLogger } from "ngx-logger";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  selector: "app-viewer-pratica-sanita",
  templateUrl: "./dialog-viewer-pratica.component.html",
  styleUrls: ["./pratiche-sanita.component.scss"],
})
export class DialogViewerPraticaSanita implements OnInit {
  public urlViewer: SafeResourceUrl;

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    if (this.config.data && this.config.data.urlViewer) {
      // Sanitizza l'URL per permettere il caricamento nell'iframe
      this.urlViewer = this.sanitizer.bypassSecurityTrustResourceUrl(this.config.data.urlViewer);
      this.logger.info("URL Viewer caricato:", this.config.data.urlViewer);
    }
  }

  chiudi() {
    this.dialogRef.close();
  }
}
